import {getSurveyResponsesToRemove} from "./getSurveyResponsesToRemove";

const buildResponse = (value, inputId, optionId, recursiveQuestionValue) => ({
  value: JSON.stringify(value),
  configuration_input_id: inputId,
  configuration_option_id: optionId || null,
  recursive_question_value: recursiveQuestionValue,
});

const updateResponsesObject = (
  responses = {},
  block,
  value,
  option,
  recursive_question_value,
  context,
  shouldRemoveRecursiveResponses=false,
) => {
  // if the current question already exists in the responses object it means that we are in a permanent survey: thus,
  // we can use the existing response as base. otherwise, it means that we are in a survey preview, and we need to build
  // the response object from scratch (since it has missing values, such as configuration_input_id)
  const base =
    responses?.[block.id] ??
    buildResponse(value, block.id, option?.id, recursive_question_value);

  let updatedResponses = {
    ...responses,
    [block.id]: {
      ...base,
      toSave: true,
      question: block,
      value: typeof value !== "undefined" ? value : "",
      ...(option
        ? {
            option: block.options.find((o) => `${o.id}` === value),
          }
        : {}),
      recursive_question_value: recursive_question_value || null,
      ...(block.service_block_id && {
        service_block_id: block.service_block_id,
        service_block_version: block.service_block_version,
      })
    },
  };

  if (shouldRemoveRecursiveResponses) {
    // we are evaluating the current recursion's responses that need to be removed
    const currentRecursionContext = {...context, responses: updatedResponses};
    const idsToRemove = getSurveyResponsesToRemove(block.id, currentRecursionContext);
    updatedResponses = _.omit(updatedResponses, idsToRemove);
  }

  return updatedResponses;
};

export default updateResponsesObject;
